<template>
  <div class="">
    <el-container>
      <el-main>
        <el-table :data="tableData" :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="500" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border style="width: 100%;margin-top: 1%">
          <el-table-column label="文件系统" min-width="120%">
            <template v-slot="scope">
              <span>{{scope.row.fileName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="磁盘容量" min-width="100%">
            <template v-slot="scope">
              <span>{{scope.row.total}}</span>
            </template>
          </el-table-column>
          <el-table-column label="已用空间" min-width="100%">
            <template v-slot="scope">
              <span>{{scope.row.used}}</span>
            </template>
          </el-table-column>
          <el-table-column label="可用空间" min-width="100%">
            <template v-slot="scope">
              <span>{{scope.row.remain}}</span>
            </template>
          </el-table-column>
          <el-table-column label="已用占比" min-width="100%">
            <template v-slot="scope">
              <span>{{scope.row.usedPer}}</span>
            </template>
          </el-table-column>
          <el-table-column label="挂载点" min-width="100%">
            <template v-slot="scope">
              <span>{{scope.row.mount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100%">
            <el-button type="warning" size="small">/</el-button>
          </el-table-column>
        </el-table>

        <!--<pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>-->

      </el-main>
    </el-container>

  </div>

</template>

<script>


export default {
  name: 'disk_list',
  components: {
    //Pagination,
  },
  mounted: function () {
    let _this = this
    _this.list()
  },
  data() {
    return {
      tableData:[],
      loading: '',
      diskJs: require('../../../api/disk')
    }
  },
  methods: {
    cleardisk(){
      let _this=this
      _this.$confirm('此操作将清理磁盘长时间日志文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                _this.loading = _this.$loading({
                  lock: true,
                  text: '正在清理中',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _this.$ajax.get(process.env.VUE_APP_SERVER + '/system/sys-free/clear-disk')
                        .then(res => {
                          if (res.data.code === '0') {
                            if(res.data.data===true){
                              _this.$alert("清理磁盘空间成功！")
                              _this.loading.close()
                            }else{
                              _this.$alert("清理磁盘空间成功！")
                              _this.loading.close()
                            }
                          }
                        })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
                _this.loading.close()
              })

    },
    list() {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.diskJs.getDisk()
              .then(res => {
                if (res.data.code === '0') {
                  _this.tableData = res.data.data
                }
              })
    },
  }
}
</script>

<!--<style scoped>-->
<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btns {
  margin-left: 30px;
  margin-top: 0px !important;
}
/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}

.my_checkbox__inner {
  border: none;
}

.my_checkbox__label {
  padding-left: 5px;
}

.my_checkbox {
  margin-right: 15px;
}

.el-table td,
.el-table th.is-leaf {
  padding: 0px !important;
}

.el-table td,
.el-table th {
  padding: 0px !important;
}

.el-form-item label {
  font-size: 16px;
}

.el-form-item__label .wrapper {
  color: red;
}

._select {
  width: 20%;
  height: 34px;
}

.pup {
  float: right;
}

.col-md-3 {
  float: left;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.float_right {
  float: right;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
}

.el-form-item {
  margin-bottom: 0px;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
/*.el-input{
        width: 80%;
    }*/
</style>

